// @ts-nocheck
import * as Types from '../../types/types';

import * as Operations from '../../queries';
import * as Apollo from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetPersonDataForMediaInjectionQueryVariables = Types.Exact<{
  personIds:
    | Array<Types.Scalars['PersonId']['input']>
    | Types.Scalars['PersonId']['input'];
}>;

export type GetPersonDataForMediaInjectionQuery = {
  __typename?: 'Query';
  persons: {
    __typename?: 'PersonConnection';
    filteredCount: number;
    edges?: Array<{
      __typename?: 'PersonEdge';
      node?: {
        __typename?: 'Person';
        id: string;
        oid: string;
        firstName?: string | null;
        lastName?: string | null;
        customerReference?: string | null;
        prefixAcademicTitle?: {
          __typename?: 'AcademicTitle';
          id: string;
          oid: string;
          name?: string | null;
        } | null;
        postfixAcademicTitle?: {
          __typename?: 'AcademicTitle';
          id: string;
          oid: string;
          name?: string | null;
        } | null;
        personTypes: {
          __typename?: 'PersonTypeConnection';
          edges?: Array<{
            __typename?: 'PersonTypeEdge';
            node?: {
              __typename?: 'PersonType';
              id: string;
              oid: string;
              name?: string | null;
              customerReference?: string | null;
              sortCode?: number | null;
            } | null;
          }> | null;
        };
        employments: {
          __typename?: 'EmploymentConnection';
          edges?: Array<{
            __typename?: 'EmploymentEdge';
            node?: {
              __typename?: 'Employment';
              function?: {
                __typename?: 'EmployeeFunction';
                id: string;
                oid: string;
                customerReference?: string | null;
                name?: string | null;
              } | null;
            } | null;
          }> | null;
        };
        specialities: {
          __typename?: 'PersonSpecialityConnection';
          edges?: Array<{
            __typename?: 'PersonSpecialityEdge';
            node?: {
              __typename?: 'PersonSpeciality';
              sortCode?: number | null;
              speciality?: {
                __typename?: 'Speciality';
                id: string;
                oid: string;
                name?: string | null;
                customerReference?: string | null;
              } | null;
            } | null;
          }> | null;
        };
        attributes: {
          __typename?: 'EntityAttributeConnection';
          filteredCount: number;
          edges?: Array<{
            __typename?: 'EntityAttributeEdge';
            node?: {
              __typename?: 'EntityAttribute';
              attribute: {
                __typename?: 'Attribute';
                id: string;
                oid: string;
                name: string;
                customerReference?: string | null;
                type: Types.AttributeType;
                usageType: Types.AttributeUsageType;
                options: Array<{
                  __typename?: 'AttributeOption';
                  id: string;
                  oid: string;
                  customerReference?: string | null;
                  value: string;
                  sequence: number;
                }>;
              };
              values: Array<{
                __typename?: 'AttributeValue';
                oid: string;
                booleanValue?: boolean | null;
                dateValue?: string | null;
                numericValue?: number | null;
                textValue?: string | null;
                documentValue?: {
                  __typename?: 'Document';
                  id: string;
                  oid: string;
                } | null;
                optionValue?: {
                  __typename?: 'AttributeOption';
                  id: string;
                  oid: string;
                  value: string;
                  customerReference?: string | null;
                } | null;
              } | null>;
            } | null;
          }> | null;
        };
        consents: {
          __typename?: 'PersonConsentConnection';
          edges?: Array<{
            __typename?: 'PersonConsentEdge';
            node?: {
              __typename?: 'PersonConsent';
              id: string;
              oid?: string | null;
              lifecycleState: Types.PersonConsentLifecycleState;
              consentType: {
                __typename?: 'ConsentType';
                id: string;
                oid: string;
                name: string;
                customerReference?: string | null;
                state: Types.State;
                lifecycleStatus?: Types.LifecycleStatus | null;
              };
              consentItemValues: Array<{
                __typename?: 'PersonConsentItemValue';
                consentItemState: Types.ConsentItemStateChange;
                consentItem: {
                  __typename?: 'ConsentItem';
                  oid: string;
                  name: string;
                };
                communicationDataValues: Array<{
                  __typename?: 'PersonConsentCommunicationDataValue';
                  value?: string | null;
                  consentCommunicationDataType: {
                    __typename?: 'ConsentCommunicationDataType';
                    oid: string;
                    communicationDataType: {
                      __typename?: 'CommunicationDataType';
                      id: string;
                      oid: string;
                      customerReference?: string | null;
                      name?: string | null;
                    };
                  };
                }>;
              }>;
            } | null;
          }> | null;
        };
      } | null;
    }> | null;
  };
};

/**
 * __useGetPersonDataForMediaInjectionQuery__
 *
 * To run a query within a React component, call `useGetPersonDataForMediaInjectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonDataForMediaInjectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonDataForMediaInjectionQuery({
 *   variables: {
 *      personIds: // value for 'personIds'
 *   },
 * });
 */
export function useGetPersonDataForMediaInjectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPersonDataForMediaInjectionQuery,
    GetPersonDataForMediaInjectionQueryVariables
  > &
    (
      | {
          variables: GetPersonDataForMediaInjectionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonDataForMediaInjectionQuery,
    GetPersonDataForMediaInjectionQueryVariables
  >(Operations.getPersonDataForMediaInjection, options);
}
export function useGetPersonDataForMediaInjectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonDataForMediaInjectionQuery,
    GetPersonDataForMediaInjectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonDataForMediaInjectionQuery,
    GetPersonDataForMediaInjectionQueryVariables
  >(Operations.getPersonDataForMediaInjection, options);
}
export function useGetPersonDataForMediaInjectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonDataForMediaInjectionQuery,
        GetPersonDataForMediaInjectionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPersonDataForMediaInjectionQuery,
    GetPersonDataForMediaInjectionQueryVariables
  >(Operations.getPersonDataForMediaInjection, options);
}
export type GetPersonDataForMediaInjectionQueryHookResult = ReturnType<
  typeof useGetPersonDataForMediaInjectionQuery
>;
export type GetPersonDataForMediaInjectionLazyQueryHookResult = ReturnType<
  typeof useGetPersonDataForMediaInjectionLazyQuery
>;
export type GetPersonDataForMediaInjectionSuspenseQueryHookResult = ReturnType<
  typeof useGetPersonDataForMediaInjectionSuspenseQuery
>;
export type GetPersonDataForMediaInjectionQueryResult = Apollo.QueryResult<
  GetPersonDataForMediaInjectionQuery,
  GetPersonDataForMediaInjectionQueryVariables
>;
